export const OTHER_SYMPTOM_OPTION = "Other";

export const PATIENT_SYMPTOM_OPTIONS = [
  "Headache",
  "Traumatic brain injury",
  "Post traumatic cognitive changes",
  "Neck pain",
  "Shoulder pain",
  "Elbow pain",
  "Wrist pain",
  "Hand pain",
  "Upper extremity numbness/tingling/burning/weakness",
  "Mid back pain",
  "Low back pain",
  "Hip pain",
  "Knee pain",
  "Ankle pain",
  "Foot pain",
  "Lower extremity numbness/tingling/burning/weakness",
  OTHER_SYMPTOM_OPTION,
];
